<template>
  <div class="layout-container">
    <app-header @toggle-sidebar="isSidebarOpen = true" />
    <app-sidebar :is-open="isSidebarOpen" @close="isSidebarOpen = false" />
    <main>
      <slot />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
export default {
  name: 'MainLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar
  },
  data () {
    return {
      isSidebarOpen: false
    }
  },
  watch: {
    '$route' () {
      this.isSidebarOpen = false
    }
  }
}
</script>
